<div class="msp-table-rmk-container" [ngStyle]="containerStyle">
	@if (headers && headers.length > 0) {
		@if (enableSearching || enableCustomizeHeaders || enableExport) {
			<div class="top-container">
				<div>
					@if (enableSelecting) {
						<span class="selected-count">
							{{ selectedRowIndex.length }}
							{{
								selectedRowIndex.length === 1
									? labels.lbl_geral_selecionado?.toLowerCase()
									: labels.lbl_geral_selecionados?.toLowerCase()
							}}
						</span>
					}
				</div>
				<div class="action-container">
					@if (enableSearching) {
						<div class="action reset-filter" (click)="fCleanSearch()">{{ labels.lbl_limpar_filtros }}</div>
					}
					@if (enableCustomizeHeaders && availableHeaders?.length > 0) {
						<div class="action" (click)="customizeHeadersComponent.customizeHeaderModal.openModal()">
							{{ labels.lbl_geral_opcoes_de_coluna }}
						</div>
					}
					@if (enableExport) {
						<div class="action export-table" (click)="exportTable.emit()">
							<span>{{ labels.lbl_geral_exportar }}</span> <fa-icon [icon]="icons.faDownload"></fa-icon>
						</div>
					}
					@if (customButtons?.length > 0) {
						@for (button of customButtons; track button) {
							@if (button.url) {
								<a class="action custom" [routerLink]="button.url">
									<span>{{ button.text }}</span>
								</a>
							}
						}
					}
				</div>
			</div>
		}
		<div class="msp-table-rmk-section">
			<div class="table-container" [ngStyle]="{ 'grid-template-columns': getGridTemplateColumns() }">
				<div class="line header" [ngStyle]="{ 'grid-column-end': getGridColumnEnd() }">
					<!-- Mais uma célula para adicionar a célula do botão de selecionar -->
					@if (enableSelecting) {
						<div class="cell header">
							<input
								type="checkbox"
								[checked]="data?.length > 0 && selectedRowIndex.length === data?.length"
								[disabled]="data?.length === 0"
								(change)="toggleAllSelection()" />
						</div>
					}
					@for (header of headers; track header) {
						<div
							class="cell header"
							[ngClass]="{
								sortedBy: sort?.sortBy === header.name,
								sortable: enableSorting && allowedSortTypes.includes(header.colType),
								searchable: enableSearching && allowedSortTypes.includes(header.colType),
								filtered:
									searchData &&
									searchData[header.name] &&
									searchData[header.name].values?.length > 0 &&
									checkEveryValueNotNullOrUndefined(searchData[header.name].values),
							}"
							[ngStyle]="{ 'anchor-name': '--' + header.name }">
							@if (enableSearching) {
								<msp-table-sort-dropdown
									[headerData]="header"
									[ngStyle]="{ 'position-anchor': '--' + header.name }"
									(getSearch)="handleSearch($event)"
									#sortDropdown>
								</msp-table-sort-dropdown>
								<span
									class="search"
									(click)="allowedSortTypes.includes(header.colType) && sortDropdown.toggleDropdown($event)">
									{{ labels[header.value] || header.value }}
								</span>
							} @else {
								<span class="search">
									{{ labels[header.value] || header.value }}
								</span>
							}
							@if (enableSorting && allowedSortTypes.includes(header.colType)) {
								<span class="sort" (click)="handleSort(header)">
									<fa-icon
										[icon]="
											sort?.sortBy === header.name
												? sort?.sortOrder === 'asc'
													? icons.faSortUp
													: icons.faSortDown
												: icons.faSort
										">
									</fa-icon>
								</span>
							}
						</div>
					}
					@if (enableExpanding) {
						<div class="cell header"></div>
					}
				</div>
				@if (!isLoading && data?.length > 0) {
					@for (data of data; let dataIndex = $index; track data) {
						<div
							class="line"
							[ngClass]="{
								selected: selectedRowIndex.includes(dataIndex),
								even: dataIndex % 2 === 0,
								lineClickable: onLineClick || enableLineSelection,
								flattenLineLinks,
							}"
							[ngStyle]="{ 'grid-column-end': getGridColumnEnd() }"
							(click)="toggleSelection(dataIndex); onLineClick && onLineClick(data)">
							@if (enableSelecting) {
								<div
									class="cell"
									(contextmenu)="
										enableContextMenu && selectContextMenuRow && turnOnToggleSelection(dataIndex);
										enableContextMenu && openContextMenu($event, data)
									">
									<input type="checkbox" [checked]="selectedRowIndex.includes(dataIndex)" />
								</div>
							}

							@for (headerInfo of headers; track headerInfo) {
								@if (headerInfo.colType === 'none' && headerInfo.template) {
									<div class="cell">
										<ng-container
											*ngTemplateOutlet="
												headerInfo.template;
												context: { $implicit: data, data: data, headerInfo: headerInfo, index: dataIndex }
											">
										</ng-container>
									</div>
								} @else if (headerInfo.colType === 'action') {
									<div class="cell action">
										@for (action of headerInfo.actions; track action) {
											<span
												(click)="action.onClick(data); $event.stopPropagation()"
												[appTooltip]="action.tooltip ?? null">
												<fa-icon [icon]="action.icon"></fa-icon>
											</span>
										}
									</div>
								} @else {
									@if (!onLineRouterLink) {
										<ng-container
											*ngTemplateOutlet="
												cellRowTemplate;
												context: { $implicit: data, data: data, headerInfo: headerInfo, index: dataIndex }
											">
										</ng-container>
									} @else {
										<a [routerLink]="fnOnLineRouterLink(data)">
											<ng-container
												*ngTemplateOutlet="
													cellRowTemplate;
													context: { $implicit: data, data: data, headerInfo: headerInfo, index: dataIndex }
												">
											</ng-container>
										</a>
									}
								}
							}
							@if (enableExpanding) {
								<div class="cell expand-button last" (click)="expandRow(dataIndex); $event.stopPropagation()">
									<fa-icon [ngClass]="{ open: expandedRowIndex.includes(dataIndex) }" [icon]="icons.faAngleRight">
									</fa-icon>
								</div>
							}
						</div>
						@if (enableExpanding) {
							<div
								class="expanded-container"
								[ngClass]="{ open: expandedRowIndex.includes(dataIndex) }"
								[ngStyle]="{ 'grid-column-end': getGridColumnEnd() }">
								<ng-container
									*ngTemplateOutlet="expandedTemplate; context: { $implicit: data, data: data, index: dataIndex }">
								</ng-container>
							</div>
						}
						<div></div>
					}
				} @else if (!isLoading && data?.length === 0) {
					<div class="no-data-container" [ngStyle]="{ 'grid-column-end': getGridColumnEnd() }">
						<span>{{ labels.lbl_security_nenhum_registro }}</span>
						<fa-icon [icon]="icons.faFileCircleXmark"></fa-icon>
					</div>
				} @else {
					<cpi-square-post-loading-effect
						[barThickness]="'calc(1.5 * var(--font-size-large))'"
						[ngStyle]="{ 'grid-column-end': getGridColumnEnd() }">
					</cpi-square-post-loading-effect>
				}
			</div>
		</div>
	}
</div>

@if (enableCustomizeHeaders) {
	<msp-table-customize-headers
		[availableHeaders]="availableHeaders"
		[headers]="headers"
		[defaultHeaders]="defaultHeaders"
		(saveHeaders)="saveHeaders.emit($event)"
		#customizeHeadersComponent>
	</msp-table-customize-headers>
}

<ng-template #cellRowTemplate let-data="data" let-headerInfo="headerInfo" let-dataIndex="index">
	<div
		class="cell"
		[class.ellipsis]="headerInfo.ellipsis"
		[class.nowrap]="headerInfo.nowrap"
		(contextmenu)="
			enableContextMenu && selectContextMenuRow ? turnOnToggleSelection(dataIndex) : null;
			enableContextMenu ? openContextMenu($event, data) : null
		">
		@switch (headerInfo.colType) {
			@case ('date') {
				{{ dateService.formatDate(data[headerInfo.name]) }}
			}
			@default {
				<span [ngStyle]="handleCellMarkup(data[headerInfo.name])" [title]="handleCellValue(data[headerInfo.name])">
					{{ handleCellValue(data[headerInfo.name]) }}
				</span>
			}
		}
	</div>
</ng-template>
